import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

import { SnackbarService } from './../../../../services/snackbar.service';
import { ApiTransferConfigService } from './../../../../services/api/api-transfer-config.service';
import {
  IBatchConfig,
  IBatchConfigForm,
  IBatchConfigParameters,
  IBatchConfigParametersForm
} from './../../../../models/batch-config';
import {
  TransferConfigType,
  TransferConfigEnum,
  ICustomSelect
} from './../../../../models/generic';

@Component({
  selector: 'app-listagem-repasse',
  templateUrl: './listagem-repasse.component.html',
  styleUrls: ['./listagem-repasse.component.scss']
})
export class ListagemRepasseComponent implements OnInit {
  @Input() type!: TransferConfigType;
  @Input() invoiceOpts: ICustomSelect[] = [];
  @Input() contractOpts: ICustomSelect[] = [];
  @Input() paymentOpts: ICustomSelect[] = [];
  @Input() batchConfig!: IBatchConfig;

  @Output() deleteBatchConfigEvent = new EventEmitter<string>();

  ConfigTransferEnum = TransferConfigEnum;

  form!: FormGroup<IBatchConfigForm>;

  constructor(
    private _batchConfigService: ApiTransferConfigService,
    private _snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.form = new FormGroup<IBatchConfigForm>({
      BatchConfigId: new FormControl<string>('', { nonNullable: true }),
      Bank: new FormControl<string>('', { nonNullable: true }),
      Channel: new FormControl<string>('', { nonNullable: true }),
      Type: new FormControl<string>('', { nonNullable: true }),
      Parameters: new FormArray<FormGroup<IBatchConfigParametersForm>>(
        this.buildBatchConfigParametersForm()
      )
    });

    const changedBatchConfig: IBatchConfig = this.changeParamsBatchConfig(
      this.batchConfig,
      'split'
    );

    this.form.patchValue(changedBatchConfig);
  }

  buildBatchConfigParametersForm(): FormGroup<IBatchConfigParametersForm>[] {
    return [
      new FormGroup<IBatchConfigParametersForm>({
        BatchConfigParameterId: new FormControl<string>('', {
          nonNullable: true
        }),
        BatchStatus: new FormControl<string[]>([], { nonNullable: true }),
        ContractStatus: new FormControl<string[]>([], { nonNullable: true }),
        PaymentStatus: new FormControl<string[]>(['Nenhum'], {
          nonNullable: true
        })
      })
    ];
  }

  changeParamsBatchConfig(
    batchConfig: IBatchConfig,
    type: 'split' | 'join'
  ): IBatchConfig {
    return {
      ...batchConfig,
      Parameters: batchConfig.Parameters?.map((params) => {
        const newParams: IBatchConfigParameters = {
          BatchStatus: this.splitOrJoinStatusParams(params.BatchStatus, type),
          ContractStatus: this.splitOrJoinStatusParams(
            params.ContractStatus,
            type
          ),
          PaymentStatus: this.splitOrJoinStatusParams(
            params.PaymentStatus,
            type
          )
        };

        if (!!params.BatchConfigParameterId)
          newParams.BatchConfigParameterId = params.BatchConfigParameterId;

        if (newParams.PaymentStatus === 'Nenhum' && type === 'join')
          newParams.PaymentStatus = '';
        else if (
          (!newParams.PaymentStatus || newParams.PaymentStatus.length === 0) &&
          type === 'split'
        )
          newParams.PaymentStatus = ['Nenhum'];

        return newParams;
      })
    };
  }

  splitOrJoinStatusParams(
    status: string | string[],
    type: 'split' | 'join'
  ): string | string[] {
    if (status.length > 0) {
      return type === 'join'
        ? [...status].join(',')
        : status.toString().split(',');
    } else {
      return type === 'join' ? '' : [];
    }
  }

  get batchConfigParametersformGroup() {
    return this.form.controls['Parameters'] as FormArray;
  }

  saveManualConfig(): void {
    const batchConfig: IBatchConfig = this.changeParamsBatchConfig(
      this.form.getRawValue() as IBatchConfig,
      'join'
    );

    this._batchConfigService.updateBatchConfig(batchConfig).subscribe({
      next: (response) => {
        this._snackbarService.openSnackBar(
          'Parametro atualizado!',
          'success',
          2000
        );
      }
    });
  }

  deleteBatchConfig(): void {
    this._batchConfigService
      .deleteBatchConfig(this.batchConfig.BatchConfigId as string)
      .subscribe({
        next: (response) => {
          this.deleteBatchConfigEvent.emit(this.batchConfig.BatchConfigId);
          this._snackbarService.openSnackBar(
            'Parametro excluído!',
            'success',
            2000
          );
        }
      });
  }
}
